/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc
 */

/**
 *  Represents a single query for retrieval evaluation with its golden document IDs.
 */

/**
 *  Response containing retrieval evaluation results.
 */

/**
 *  Result for a single query evaluation.
 */

export const fetchAppParamsRpc = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'fetchAppParams',
  auth: 'app',
  fingerprint: 'YWt5zaxsXwhZIT_P_vIs6MFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const storeUserAppSecretRpc = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'storeUserAppSecret',
  auth: 'app',
  fingerprint: '-DR61q9MQT2DBtEzbRG2VcFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAppIdsRpc = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'getAppIds',
  auth: 'app',
  fingerprint: 'V2ATleAtWU7waHhvzq7C8sFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBreezeConnectorAppIdsRpc = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'getBreezeConnectorAppIds',
  auth: 'app',
  fingerprint: 'EejPgmK4f3su-UE8pdz31MFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUserConnectedAppsRpc = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'getUserConnectedApps',
  auth: 'app',
  fingerprint: 'u6Hgot8FgezxAS-o3S6DoMFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMcpServersByIdsRpc = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'getMcpServersByIds',
  auth: 'app',
  fingerprint: 'F5GO833_Z_StMMS-XV9b1sFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const disconnectUserAppRpc = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'disconnectUserApp',
  auth: 'app',
  fingerprint: 'Ap_0dmh8bkLw91e8oK9VdcFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const testGimmieSetupRpc = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'testGimmieSetup',
  auth: 'app',
  fingerprint: 'rVbbTlhpACCxeXk2Jy2h_sFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const testGimmieCleanupRpc = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'testGimmieCleanup',
  auth: 'app',
  fingerprint: 'YRjUnma4W8czWIR9vuhpjMFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const runRetrievalEvalSingleRpc = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'runRetrievalEvalSingle',
  auth: 'app',
  fingerprint: 'J6KqrEs8JqCV0JaWk37N8sFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const runRetrievalEvalRpc = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'runRetrievalEval',
  auth: 'app',
  fingerprint: 'qoqNZZJPqpOV0JaWk37N8sFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const runRetrievalEvalFromGoogleSheetRpc = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'runRetrievalEvalFromGoogleSheet',
  auth: 'app',
  fingerprint: '0XczeUTylHKV0JaWk37N8sFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};